import { Component, Input } from '@angular/core';
import { getSystemDisplayTimeZone } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'lib-date-author-info',
  templateUrl: './table-date-author.component.html',
  styleUrl: './table-date-author.component.scss',
  standalone: false,
})
export class DateAuthorInfoComponent {
  @Input() public date!: string; // Accepts a date object
  @Input() public user!: string | null; // Accepts a user string
  @Input() public isCard = false; // Accepts a boolean value
  @Input() public type = ''; // Accepts a user string
  @Input() public showTimeZone = false;

  protected get timeZone(): string {
    return getSystemDisplayTimeZone();
  }
}
